module.exports = __webpack_public_path__ + "./docs/img/icon-typedef.551ea7579c7c7cb87392fc051b193c76.svg";